import React, { useState } from 'react';
import { OpenSidebar as IconCloseArrow } from "flowbite-react-icons/outline";

interface Props {
  children: React.ReactNode;
  close: () => void;
}

const SidePanel = (props: Props) => {
  const [isOpen, setIsOpen] = useState("open");


  const close = () => {
    setIsOpen("closed");
    setTimeout(() => {
      props.close()
    }, 400);
  }

  return (
    // <div className="z-side-panel-background" onClick={() => close()}>
      <div className={"z-side-panel " + isOpen}>
        <div className="cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1"
             style={{position: "absolute", top: "16px", right: "16px"}} onClick={() => close()}>
          <IconCloseArrow className="text-gray-400" aria-hidden="true" />
        </div>
        {props.children}
      </div>
    // </div>
  )
}

export default SidePanel;